import { useState } from "react";
import { PersonaRole } from "@xemplo/gp-types";
import { RoleRenderer } from "@xemplo/role-renderer";
import { AuthorisationModule } from "@xemplo/role-types";
import { V2 } from "@xemplo/text-dropdown";
import { useListBuilder } from "@xemplo/stateful-list-core";
import {
  getStatusOptions,
  showStatusOption,
} from "./update-payrun-status.helpers";

export interface UpdatePayrunStatusProps {
  payrunStatusId: number;
  onStatusChange?: (value: number | null) => void;
}

const STATUS_CHANGE_ROLES = [
  PersonaRole.PSPAdmin,
  PersonaRole.PayrollManager,
  PersonaRole.SystemAdmin,
];

export const UpdatePayrunStatus = ({
  payrunStatusId,
  onStatusChange,
}: Readonly<UpdatePayrunStatusProps>) => {
  const { options, defaultStatus } = getStatusOptions(payrunStatusId);
  const statusList = useListBuilder(options, "value", "id");
  const [value, setValue] = useState<string | number | undefined>(
    defaultStatus,
  );
  const [displayValue, setDisplayValue] = useState(
    options.find((status) => status.id === defaultStatus)?.value ?? "",
  );

  return (
    <RoleRenderer
      module={AuthorisationModule.payrun}
      roles={STATUS_CHANGE_ROLES}
      additionalRules={[() => showStatusOption(payrunStatusId)]}
    >
      <div className="mb-2">
        <div className="mb-2">Set the pay run status to:</div>
        <V2.TextDropdown
          name="payrunStatus"
          aria-label="Pay run status"
          items={statusList}
          value={value}
          displayValue={displayValue}
          setDisplayValue={setDisplayValue}
          placeholder="Select status"
          onListChange={(selected) => {
            setValue(selected);
            onStatusChange?.((selected as number) ?? null);
          }}
        />
      </div>
    </RoleRenderer>
  );
};
